import { DataBean } from "../../DataBean";


export class ComponentTypeConstants extends DataBean {


    public async getBodyComponentTypeConstants(args:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getBodyComponentTypeConstants_Number", [args]);
    }


}